"use strict";
require.config({
    baseUrl: "./",
    paths : {
        jquery : 'lib/jquery',
        appquery : 'lib/appquery',
        bootstrap : 'lib/bootstrap.min',
        require : 'require/require',
        text : 'require/text',
        json : 'require/json',
        templates : '../templates',
        app : 'lib/app',
        panzoom : 'plugins/panzoom',
        snap : 'plugins/snap',
        fuse : 'plugins/fuse',
        astar : 'plugins/astar',
        dexie : 'plugins/dexie',
        toastr : 'plugins/toastr',
    },
    shim : {
        bootstrap : ['jquery'],
        panzoom : ['jquery'],
        snap : ['jquery'],
        astar : ['jquery'],
    },
    config: {
        text: {
            useXhr: function (url, protocol, hostname, port) {
                // allow cross-domain requests
                // remote server allows CORS
                return true;
            }
        }
    }
});

require(['jquery', 'app'], function($, App) {
    $(document).on('click', '.back', function(e) {
        e.preventDefault();
        App.page.back();
    });

    $(document).on('click', 'a[href^="#"]:not([data-toggle=collapse]),li[href^="#"]', function(e) {
        e.preventDefault();
        var that = $(this);
        var page = that.attr('href').slice(1);
        if(page) {
            App.page.render(page, that.data());
        }
    });
});

require(['jquery', 'bootstrap', 'app', 'modules/setup', "pages/login", "pages/map", "pages/message", "pages/spinner", "text!templates/login.html", "text!templates/map.html", "text!templates/message.html", "text!templates/spinner.html", "pages/main/home", "pages/main/loader", "pages/main/order", "pages/main/products", "pages/main/register", "pages/main/search", "pages/main/settings", "pages/main/utilities", "text!templates/main/home.html", "text!templates/main/loader.html", "text!templates/main/order.html", "text!templates/main/products.html", "text!templates/main/register.html", "text!templates/main/search.html", "text!templates/main/settings.html", "text!templates/main/utilities.html"], function($, bootstrap, App, Setup) {
    if(WURFL.form_factor !== "Desktop") {
        $(document).on('blur', 'input:not(.ignore):not([type=checkbox]):not([type=radio]), textarea:not(.ignore)', function(e) {
            $('#app').css('top', 0);
        });

        $(document).on('focus', 'input:not(.ignore):not([type=checkbox]):not([type=radio]), textarea:not(.ignore)', function(e) {
            var offsetTop = $('#app').offset().top - $(this).offset().top + 100;
            if(offsetTop < 0) {
                $('#app').css('top', offsetTop + 'px');
            }
            return false;
        });
    }

    App.init('main', {
        tables : {
            products : 'id'
        },
        onRetailerChange : function() {
            App.page.render('message', {
                message : '\
                    <h2>Retailer has changed</h2>\
                    <p>\
                        <button type="button" class="btn btn-custom m-r-xs" id="unregister">Unregister Previous Retailer</button>\
                        <button type="button" class="btn btn-custom" id="relogin">Login as Previous Retailer</button>\
                    </p>',
                init : function($$$) {
                    $$$('#unregister').click(function(){
                        Setup.unregister(true);
                    });
                    $$$('#relogin').click(function(){
                        App.page.login(data);
                    });
                }
            });
            return true;
        },
        onLogin : function(userData) {
            App.page.render('register');
        }
    });

    App.page.render('spinner', 'Checking resources...', true);
    checkAvailableResources(function(resourcesAvailable) {
        if(resourcesAvailable == true) {
            Setup.checkExpiry(function() {
                App.page.render('home');
            });
        } else {
            App.page.login(resourcesAvailable);
        }
    });

    //Whenever a new param is added please update this function
    function checkAvailableResources(callback) {
        var resources = {
            registration : ['retailer_id', 'device_id'],
            compulsary : ['store'],
            location : ["map_source", "map_floor"],
            map : ["map_floors", "map_racks", "map_utilities", "map_floor_*"],
            product : ["products"],
        };

        var allResources = Object.keys(resources).reduce(function(prev, curr){
            return prev.concat(resources[curr]);
        }, []);

        App.database.get(allResources, function(data) {
            App.global(data);

            //If device_id is not available start fresh
            if(!hasValues(data, resources.registration)) {
                App.global('clear');
                callback();
                return;
            }

            //If store is not available fetch
            if(!hasValues(data, resources.compulsary)) {
                App.global('clearAllExcept', resources.registration);
                callback({
                    onLogin : function() {
                        Setup.fetchDeviceInfo();
                    }
                });
                return;
            }

            //If location information is not available
            var noLocation = !hasValues(data, resources.location);

            function getCallback(load) {
                if(noLocation) {
                    return function() {
                        Setup.fetchDeviceInfo(load);
                    };
                } else {
                    return function() {
                        Setup.updateData(load);
                    };
                }
            }

            App.database.instance.products.count(function(count) {
                var noMap = false;
                var noProducts = false;

                if(!hasValues(data, resources.product) || !count || count != data.products.length) {
                    noProducts = true;
                }

                var mapResources = resources.map.slice(0,-1);
                (data.map_floors || []).forEach(function(f) {
                    mapResources.push('map_floor_'+f);
                });

                if(!hasValues(data, mapResources)) {
                    noMap = true;
                }

                //If map and products are not available start fresh
                if(noMap && noProducts) {
                    App.global('clearAllExcept', resources.registration);
                    callback({
                        onLogin : function() {
                            Setup.fetchDeviceInfo();
                        },
                        message : "Device information missing, login to fetch"
                    });
                    return;
                }
                //If only map is not available, login and update layout
                else if(noMap) {
                    callback({
                        onLogin : getCallback('layout'),
                        message : "Map information is missing, login to fetch"
                    });
                    return;
                }
                //If only products are not available, login and update layout
                else if(noProducts) {
                    callback({
                        onLogin : getCallback('products'),
                        message : "Some of the products are missing, login to fetch"
                    });
                    return;
                }


                if(noLocation) {
                    callback({
                        onLogin : function() {
                            Setup.fetchDeviceInfo(function() {
                                Setup.checkLocationAndReload();
                            });
                        },
                        message : noLocation ? "Map location is missing, login to fetch" : "Device information missing, login to fetch"
                    });
                    return;
                }

                callback(true);
            });
        });
    }

    function hasValues(obj, array) {
        array = array.slice(0);
        var has = true;
        while(has && array.length) {
            has = obj[array.shift()] != null;
        }
        return has;
    }
});
define("main", function(){});

